export function fireWhenDOMReady(cb: (...args: unknown[]) => void): void {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cb, {once: true});
  } else {
    cb();
  }
}
